import PageContainer from '@/common/components/PageContainer'
import WebsiteBrandingListing from '@/modules/client-setting/components/WebsiteBranding/components/WebsiteBrandingListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function WebsiteBrandingPage() {
	return (
		<PageContainer>
			<WebsiteBrandingListing />
		</PageContainer>
	)
}

const GuardedWebsiteBrandingPage = withUserPermission(WebsiteBrandingPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.WEB_SETTING],
})

export default GuardedWebsiteBrandingPage
